import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';

// services
import ProjectService from '../../service/project-service';
import ClipService from '../../service/clip-service';

// store
import { storeSet } from '../../store';

// helpers
import displayNetworkError from '../../helpers/displayNetworkError';

// components
import FormField from '../FormField';
import ButtonFlat from '../ButtonWrapper/components/ButtonFlat';
import ButtonFormSubmit from '../ButtonWrapper/components/ButtonFormSubmit';
import ModalDialog from '../ModalDialog';
import handleSuccessAndDisplay from '../../helpers/handleSuccessAndDisplay';

// styles
import './ModalUploadSimple.css';

const ModalUploadSimple = ({
    projectId,
    type,
    headerText,
    onCreated,
    onClose
}) => {
    const [loading, setLoading] = useState(false);
    const {
        control,
        handleSubmit,
        formState: { isValid },
        reset
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            label: '',
            title: '',
            file: null
        }
    });

    const defaultHeaders = {
        references: __('Carica riferimento', 'soundbetween'),
        rec: __('Nuova sessione di registrazione', 'soundbetween')
    };

    const header = headerText || defaultHeaders[type] || __('Carica file', 'soundbetween');

    const isRec = type === 'rec';

    const onSubmit = async (formData) => {
        setLoading(true);

        try {
            if (isRec) {
                // Only the session is created here: the main track is uploaded
                // later, from "Aggiungi traccia principale".
                const created = await storeSet('createRecSession', projectId, {
                    title: formData.title,
                    label: formData.label,
                });
                if (created?.id) onCreated?.(created);
            } else {
                const createdItem = await ProjectService.createProjectCueSheetItemAsync(projectId, {
                    cue_type: 'REFERENCE',
                    label: formData.label,
                    title: formData.title,
                    timecode: '00:00:00:00'
                });

                const formDataToSend = new FormData();
                formDataToSend.append('file', formData.file);

                await ClipService.createClipAsync(formDataToSend, [
                    ['projectId', projectId],
                    ['clipType', 'REFERENCE'],
                    ['cueSheetId', createdItem.id]
                ]);

                storeSet('refetchCueSheet', projectId);

                handleSuccessAndDisplay(__('Riferimento caricato con successo', 'soundbetween'));
            }

            reset();
            onClose();
        } catch (error) {
            displayNetworkError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        reset();
        onClose();
    };

    return (
        <ModalDialog
            additionalClasses={['modalUploadSimple']}
            header={header}
            visible={true}
            onSubmit={handleSubmit(onSubmit)}
            onHide={handleCloseModal}>
            <form className="appForm formInModal" onSubmit={handleSubmit(onSubmit)}>
                {isRec && (
                    <p className="modalUploadSimple__intro">
                        {__('Crea la sessione con label e titolo. La traccia principale potrai caricarla dopo, con "Aggiungi traccia principale", e invitare i collaboratori.', 'soundbetween')}
                    </p>
                )}
                <FormField
                    type="text"
                    name="label"
                    label={__('Label', 'soundbetween')}
                    placeholder={__('es 1m3', 'soundbetween')}
                    control={control}
                    rules={{
                        required: __('È obbligatorio', 'soundbetween')
                    }}
                />

                <FormField
                    control={control}
                    name="title"
                    label={__('Titolo', 'soundbetween')}
                    placeholder={__('Inserisci titolo', 'soundbetween')}
                    type="text"
                    rules={{
                        required: __('È obbligatorio', 'soundbetween')
                    }}
                />

                {!isRec && (
                    <FormField
                        control={control}
                        name="file"
                        label={__('Carica file', 'soundbetween')}
                        placeholder={__('Scegli un file', 'soundbetween')}
                        type="fileupload"
                        accept=".mp3"
                        rules={{
                            required: __('È obbligatorio', 'soundbetween')
                        }}
                    />
                )}

                <div className="appFormActions">
                    <ButtonFlat size="lg" type="button" onClick={handleCloseModal}>
                        {__('Annulla', 'soundbetween')}
                    </ButtonFlat>
                    <ButtonFormSubmit disabled={loading || !isValid}>
                        {isRec ? __('Crea sessione', 'soundbetween') : __('Salva', 'soundbetween')}
                    </ButtonFormSubmit>
                </div>
            </form>
        </ModalDialog>
    );
};

export default ModalUploadSimple;
